import { useState, useEffect } from 'react';
import { collection, query, where, orderBy, onSnapshot, addDoc, updateDoc, deleteDoc, doc, serverTimestamp } from 'firebase/firestore';
import { db } from '../lib/firebase';

export function useTasks(filterArtistId = null) {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let q = query(collection(db, 'tasks'), orderBy('createdAt', 'desc'));
    if (filterArtistId) q = query(collection(db, 'tasks'), where('artistId', '==', filterArtistId), orderBy('createdAt', 'desc'));
    return onSnapshot(q, snap => { setTasks(snap.docs.map(d => ({ id: d.id, ...d.data() }))); setLoading(false); });
  }, [filterArtistId]);
  const addTask = async (task) => addDoc(collection(db, 'tasks'), { ...task, createdAt: serverTimestamp() });
  const updateTask = async (id, updates) => updateDoc(doc(db, 'tasks', id), updates);
  const deleteTask = async (id) => deleteDoc(doc(db, 'tasks', id));
  return { tasks, loading, addTask, updateTask, deleteTask };
}

export function useScripts(filterArtistId = null) {
  const [scripts, setScripts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let q = query(collection(db, 'scripts'), orderBy('createdAt', 'desc'));
    if (filterArtistId) q = query(collection(db, 'scripts'), where('artistId', '==', filterArtistId), orderBy('createdAt', 'desc'));
    return onSnapshot(q, snap => { setScripts(snap.docs.map(d => ({ id: d.id, ...d.data() }))); setLoading(false); });
  }, [filterArtistId]);
  const addScript = async (script) => addDoc(collection(db, 'scripts'), { ...script, status: 'draft', createdAt: serverTimestamp() });
  const updateScript = async (id, updates) => updateDoc(doc(db, 'scripts', id), updates);
  const deleteScript = async (id) => deleteDoc(doc(db, 'scripts', id));
  const submitForApproval = async (id) => updateDoc(doc(db, 'scripts', id), { status: 'pending' });
  const approveScript = async (id, approverId) => updateDoc(doc(db, 'scripts', id), { status: 'approved', approvedBy: approverId, approvedAt: serverTimestamp() });
  return { scripts, loading, addScript, updateScript, deleteScript, submitForApproval, approveScript };
}

export function useSongs(artistId = null) {
  const [songs, setSongs] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let q = query(collection(db, 'songs'), orderBy('title'));
    if (artistId) q = query(collection(db, 'songs'), where('artistId', '==', artistId), orderBy('title'));
    return onSnapshot(q, snap => { setSongs(snap.docs.map(d => ({ id: d.id, ...d.data() }))); setLoading(false); });
  }, [artistId]);
  const addSong = async (song) => addDoc(collection(db, 'songs'), { ...song, createdAt: serverTimestamp() });
  const updateSong = async (id, updates) => updateDoc(doc(db, 'songs', id), updates);
  return { songs, loading, addSong, updateSong };
}

export function useArtists() {
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    return onSnapshot(collection(db, 'artists'), snap => { setArtists(snap.docs.map(d => ({ id: d.id, ...d.data() }))); setLoading(false); });
  }, []);
  return { artists, loading };
}

export function useReleases(artistId = null) {
  const [releases, setReleases] = useState([]);
  useEffect(() => {
    let q = query(collection(db, 'releases'), orderBy('createdAt', 'desc'));
    if (artistId) q = query(collection(db, 'releases'), where('artistId', '==', artistId), orderBy('createdAt', 'desc'));
    return onSnapshot(q, snap => setReleases(snap.docs.map(d => ({ id: d.id, ...d.data() }))));
  }, [artistId]);
  const addRelease = async (r) => addDoc(collection(db, 'releases'), { ...r, createdAt: serverTimestamp() });
  const updateChecklist = async (id, items) => updateDoc(doc(db, 'releases', id), { checklistItems: items });
  return { releases, addRelease, updateChecklist };
}